import React, {useEffect} from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import {Box, StepLabel} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {getCurrentSteps, isDealerSite, isWidget} from "../../utils/utils";
import {useIsAuthenticated} from "react-auth-kit";
import ColorlibStepIcon from "./StepIcon/StepIcon";
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setStep} from "../../redux/actions/stepActions";
import TripDetails from "./Summary/TripDetails";
import NautilusConnector from "../Common/NautilusConnector";

const useStyles = makeStyles({
    stepper: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 40,
    },
    stepLabelLabel: {
        fontSize: '0.8rem',
    },
    textMobile: {
        '& $stepLabelLabel': {
            fontSize: '0.8rem',
        },
    },
});

const BookingStepper = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const step = useSelector(state => state.step);
    const {data: trip} = useSelector(state => state.trip);
	const isAuth = useIsAuthenticated();
    const dataSteps = getCurrentSteps();
    const _steps = (isDealerSite() && (isAuth() !== true)) ? dataSteps.filter(dataStep => dataStep.label !== 'Activities') : dataSteps;

    const bookingId = trip?.TripId;

    const classes = useStyles();
    const prefixUrl = isWidget()?'plugin':'booking';
    const moveToStep = index => {
        const {url} = _steps.find(s => s.index === index);
        dispatch(setStep(index));
        const searchParams = sessionStorage.getItem('searchParams');
        if(index > 0){
            history.push(`/${prefixUrl}/${bookingId}${url}`);
        }
        else{
            const finalUrl = searchParams ? 
                `${url}${searchParams}` : 
                url;
            history.push(finalUrl);
        }
    };


    return (<>
            {step > 1 && trip && Object.keys(trip).length > 0 &&
            <Box sx={{display: {xs: 'block', sm: 'none'}}}><TripDetails/></Box>}
            <Stepper alternativeLabel activeStep={step} className={classes.stepper}
                     connector={<NautilusConnector/>}>
                {_steps.length > 0 && _steps.map((st) => {
                    return (
                        <Step key={st.index}>
                            <StepLabel StepIconComponent={ColorlibStepIcon} sx={{cursor: 'pointer'}}
                                       onClick={() => st.index <= step ?moveToStep(st.index):null}
                                // completed={isCompleted(index)}
                            >
                                <span style={{fontSize: '1.4rem'}}>{st.label}</span>
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </>
    );
}

export default BookingStepper;